import { Component, Inject, OnDestroy, OnInit } from "@angular/core";
import { Store } from "@ngrx/store";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { Userprofile } from "src/app/_models/Userprofile";
import { UserProfileService } from "src/app/_services/userprofile.service";
import { GetOwnUserProfile, ResetOwnUserProfile } from "src/app/_store/user-profile/user-profile.actions";
import { selectOwnUserProfile } from "src/app/_store/user-profile/user-profile.selectors";
import { Roles } from "src/app/constants/Roles";
import { APP_CONFIG } from "src/app/lib/angular/injection-tokens";
import { IAppConfig } from "src/app/lib/config/app-config";

@Component({
  selector: "app-admin",
  templateUrl: "./admin.component.html",
  styleUrls: ["./admin.component.scss"],
})
export class AdminComponent implements OnInit, OnDestroy {
  currentUserProfile: Userprofile
  ifCurrentUserIsSystemAdmin: boolean;
  adminComponentDestroy$: Subject<void> = new Subject<void>();
  isDevEnvironment: boolean;

  constructor(
    private store: Store,
    @Inject(APP_CONFIG) private config: IAppConfig
  ) {
  }

  ngOnInit(): void {
    this.isDevEnvironment = this.config.isDevEnvironment;
    this.store.dispatch(ResetOwnUserProfile());
    
    this.store.select(selectOwnUserProfile)
      .pipe(takeUntil(this.adminComponentDestroy$))
      .subscribe((userProfileResult: Userprofile) => {
        if (userProfileResult !== null)
        {
          this.setCurrentUserProfile(userProfileResult);
        }
      });

    this.getCurrentUserProfile();
  }

  ngOnDestroy(): void {
    this.adminComponentDestroy$.next();
    this.adminComponentDestroy$.unsubscribe();
  }

  getCurrentUserProfile(): void {
    this.store.dispatch(GetOwnUserProfile());
  }
  
  setCurrentUserProfile(userProfile: Userprofile): void {
    this.currentUserProfile = userProfile;
    this.ifCurrentUserIsSystemAdmin = this.currentUserProfile.roleId === Roles.SystemAdministrator;
  }
}
